import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/solid';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import {loadMessages, locale} from 'devextreme/localization';
import ptBrMessages from 'devextreme/localization/messages/pt.json';
import config from "devextreme/core/config";
import './css/dx_generic_cores_raster.css';
import './css/dx.generic.compacto-datagrid.css';
import './css/basicas.css';
import './css/jornada.css';
import './css/styles.css';
import './css/formulario.css';
import './css/formulario_pre-sm.css';
import "vis-timeline/styles/vis-timeline-graph2d.css";
import {keycloakServiceFactory} from "./services/keycloak";
import selecionaEmpresa from "./login/selecionaEmpresa";
import {login} from "./services/auth/api";
import {errorHandler} from "./utils/errorHandler";
import { setUserTheme } from './services/user-theme';

loadMessages(ptBrMessages)
locale('pt-BR')
config({
    defaultCurrency: 'BRL',
    forceIsoDateParsing: true,
})

const clearParams = (url, params) => {
    params.delete('code');
    params.delete('session_state');
    params.delete('state');

    const novaUrl = `${url.origin}${url.pathname}`;

    history.replaceState(null, '', novaUrl);
}

$(async () => {
    try {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);

        const authorizationCode = urlParams.get("code")
        const sessionState = urlParams.get("session_state")
        const state = urlParams.get("state")

        clearParams(url, urlParams)

        const isLogged = Boolean(authorizationCode && sessionState)

        const keycloakService = keycloakServiceFactory()

        if (!isLogged) {
            keycloakService.redirectToLogin()
            return
        }

        const isValidState = keycloakService.checkValidState(state)

        if (!isValidState) {
            throw {code: 'E_AUTH_INVALID_STATE_AUTHORIZATION'}
        }

        await login(authorizationCode)

        await setUserTheme()

        new selecionaEmpresa();
    } catch (err) {
        errorHandler(err, "auth")
        console.log(err);
    }
})
